module.exports = __webpack_public_path__ + "static/media/sample3.0c4af288.png";